module.exports = "https://p.cds.unp.clasificados.pe/roboto-bold.f792bc98698c0c9c21f1bcb147009838.woff2";